import styled from "styled-components";

// TODO get rid of these

export const Subheading = styled.h3`
  font-weight: 400;
`;
